import React, { useMemo } from 'react';
import OTKStatistics from '../otk/output/OTKStatistics';

/**
 * CRM Kvalita výroby (cust004) – reuse QLTY015 / OTKStatistics s CRM-scoped API.
 */
export default function CustomerProductionQuality({
  preview = null,
  timePeriod = null,
  date = null,
  drilldownRecords = null,
  customerIds = null,
  presetCustomerIds = null,
} = {}) {
  const resolvedCustomerIds = useMemo(() => {
    if (Array.isArray(presetCustomerIds) && presetCustomerIds.length > 0) {
      return presetCustomerIds;
    }
    if (Array.isArray(customerIds) && customerIds.length > 0) {
      return customerIds;
    }
    return null;
  }, [customerIds, presetCustomerIds]);

  return (
    <OTKStatistics
      preview={preview}
      timePeriod={timePeriod}
      date={date}
      drilldownRecords={drilldownRecords}
      ajaxURL="/api/customer_evaluations/production_quality/paged"
      listPageKey="CustomerProductionQuality"
      presetCustomerIds={resolvedCustomerIds}
    />
  );
}
